import { dew as _coreDew } from "../../../../core";
import { dew as _Dew } from "../../..";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  /**
   * This file was auto-generated by Fern from our API Definition.
   */
  var __createBinding = exports && exports.__createBinding || (Object.create ? function (o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = {
        enumerable: true,
        get: function () {
          return m[k];
        }
      };
    }
    Object.defineProperty(o, k2, desc);
  } : function (o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
  });
  var __setModuleDefault = exports && exports.__setModuleDefault || (Object.create ? function (o, v) {
    Object.defineProperty(o, "default", {
      enumerable: true,
      value: v
    });
  } : function (o, v) {
    o["default"] = v;
  });
  var __importStar = exports && exports.__importStar || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
  };
  var __awaiter = exports && exports.__awaiter || function (thisArg, _arguments, P, generator) {
    function adopt(value) {
      return value instanceof P ? value : new P(function (resolve) {
        resolve(value);
      });
    }
    return new (P || (P = Promise))(function (resolve, reject) {
      function fulfilled(value) {
        try {
          step(generator.next(value));
        } catch (e) {
          reject(e);
        }
      }
      function rejected(value) {
        try {
          step(generator["throw"](value));
        } catch (e) {
          reject(e);
        }
      }
      function step(result) {
        result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
      }
      step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
  };
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.Event = void 0;
  const core = __importStar(_coreDew());
  exports.Event = core.serialization.union("topic", {
    "agent:created": core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () {
      return (yield Promise.resolve().then(() => __importStar(_Dew()))).GenericEvent;
    })),
    "agent:updated": core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () {
      return (yield Promise.resolve().then(() => __importStar(_Dew()))).GenericEvent;
    })),
    "agent:deleted": core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () {
      return (yield Promise.resolve().then(() => __importStar(_Dew()))).GenericEvent;
    })),
    "space:created": core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () {
      return (yield Promise.resolve().then(() => __importStar(_Dew()))).GenericEvent;
    })),
    "space:updated": core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () {
      return (yield Promise.resolve().then(() => __importStar(_Dew()))).GenericEvent;
    })),
    "space:deleted": core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () {
      return (yield Promise.resolve().then(() => __importStar(_Dew()))).GenericEvent;
    })),
    "document:created": core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () {
      return (yield Promise.resolve().then(() => __importStar(_Dew()))).GenericEvent;
    })),
    "document:updated": core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () {
      return (yield Promise.resolve().then(() => __importStar(_Dew()))).GenericEvent;
    })),
    "document:deleted": core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () {
      return (yield Promise.resolve().then(() => __importStar(_Dew()))).GenericEvent;
    })),
    "workbook:created": core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () {
      return (yield Promise.resolve().then(() => __importStar(_Dew()))).GenericEvent;
    })),
    "workbook:updated": core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () {
      return (yield Promise.resolve().then(() => __importStar(_Dew()))).GenericEvent;
    })),
    "workbook:deleted": core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () {
      return (yield Promise.resolve().then(() => __importStar(_Dew()))).GenericEvent;
    })),
    "sheet:created": core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () {
      return (yield Promise.resolve().then(() => __importStar(_Dew()))).GenericEvent;
    })),
    "sheet:updated": core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () {
      return (yield Promise.resolve().then(() => __importStar(_Dew()))).GenericEvent;
    })),
    "sheet:deleted": core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () {
      return (yield Promise.resolve().then(() => __importStar(_Dew()))).GenericEvent;
    })),
    "snapshot:created": core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () {
      return (yield Promise.resolve().then(() => __importStar(_Dew()))).GenericEvent;
    })),
    "records:created": core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () {
      return (yield Promise.resolve().then(() => __importStar(_Dew()))).GenericEvent;
    })),
    "records:updated": core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () {
      return (yield Promise.resolve().then(() => __importStar(_Dew()))).GenericEvent;
    })),
    "records:deleted": core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () {
      return (yield Promise.resolve().then(() => __importStar(_Dew()))).GenericEvent;
    })),
    "file:created": core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () {
      return (yield Promise.resolve().then(() => __importStar(_Dew()))).GenericEvent;
    })),
    "file:updated": core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () {
      return (yield Promise.resolve().then(() => __importStar(_Dew()))).GenericEvent;
    })),
    "file:deleted": core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () {
      return (yield Promise.resolve().then(() => __importStar(_Dew()))).GenericEvent;
    })),
    "job:created": core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () {
      return (yield Promise.resolve().then(() => __importStar(_Dew()))).GenericEvent;
    })),
    "job:updated": core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () {
      return (yield Promise.resolve().then(() => __importStar(_Dew()))).GenericEvent;
    })),
    "job:deleted": core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () {
      return (yield Promise.resolve().then(() => __importStar(_Dew()))).GenericEvent;
    })),
    "job:failed": core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () {
      return (yield Promise.resolve().then(() => __importStar(_Dew()))).GenericEvent;
    })),
    "job:completed": core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () {
      return (yield Promise.resolve().then(() => __importStar(_Dew()))).GenericEvent;
    })),
    "job:ready": core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () {
      return (yield Promise.resolve().then(() => __importStar(_Dew()))).GenericEvent;
    })),
    "job:scheduled": core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () {
      return (yield Promise.resolve().then(() => __importStar(_Dew()))).GenericEvent;
    })),
    "job:outcome-acknowledged": core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () {
      return (yield Promise.resolve().then(() => __importStar(_Dew()))).GenericEvent;
    })),
    "commit:created": core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () {
      return (yield Promise.resolve().then(() => __importStar(_Dew()))).GenericEvent;
    })),
    "commit:updated": core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () {
      return (yield Promise.resolve().then(() => __importStar(_Dew()))).GenericEvent;
    })),
    "commit:completed": core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () {
      return (yield Promise.resolve().then(() => __importStar(_Dew()))).GenericEvent;
    })),
    "layer:created": core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () {
      return (yield Promise.resolve().then(() => __importStar(_Dew()))).GenericEvent;
    }))
  }).transform({
    transform: value => value,
    untransform: value => value
  });
  return exports;
}